import React from 'react'

/*

Renders a legacy beaker image that's attached to a break / step

(for now just spits out an img tag)

image parameter takes the shape:
    "image": {
        "id": "76942d14-f95f-45c5-b2c8-73e41a823005",
        "name": "iStock-1131049630-personalityQuestion",
        "source": "iStock",
        "link": "",
        "altAttribute": "airplane flying through sunset"
    }


*/

export const legacyImageURL = image => {
  if (!image) {
    return '' // not sure what a good response is for this
  }

  return `${process.env.SITE_ASSET_URL}/${image.id}`
}

// Beaker stores each upload at `{id}` (1x) and `{id}_2x` (double size, e.g.
// 600x400 for a 300x200 image). Images uploaded before December 2020 may have
// no `_2x`, so pair this with a fallback to legacyImageURL.
export const legacyRetinaImageURL = image => {
  if (!image) {
    return ''
  }

  return `${legacyImageURL(image)}_2x`
}

const LegacyImage = ({ image, setInteracted, style }) => {
  if (!image) {
    return false
  }

  return (
    <img
      style={{ width: `100%`, ...style }}
      src={`${process.env.SITE_ASSET_URL}/${image.id}`}
      alt={image.alt || image.name}
      onClick={() => setInteracted && setInteracted(true)}
    />
  )
}

export default LegacyImage
